//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/plus-around.svg';

const RegularMedia = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/RegularMedia.vue');

export default {
  name: 'MediaAndOverlay',
  components: {
    RegularMedia
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    },
    videoMp4: {
      type: String,
      default: ''
    },
    videoWebm: {
      type: String,
      default: ''
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    iconPlayColor: {
      type: String,
      default: '#ffffff'
    },
    hasOverlay: {
      type: Boolean,
      default: false
    },
    ratioImg: {
      type: String,
      default: '1:1'
    },
    componentType: {
      type: String,
      default: 'default'
    },
    url: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    },
    overlayType: {
      type: String,
      default: 'plain',

      validator(value) {
        return ['plain', 'gradient'].includes(value);
      }

    }
  },

  data() {
    return {
      isPaused: !this.autoPlay
    };
  },

  computed: {
    href() {
      return this.componentType === 'link' ? 'href' : '';
    }

  }
};